import React from 'react';

import type { Row as TanstackRow } from '@tanstack/react-table';

import { IconButton } from '@atlaskit/button/new';

import { ExpandIcon } from '../../../ui/primitives/expand-icon';
import type { CharlieTableProps } from '../../charlie-table.types';

export type ExpandRowButtonProps<T extends object> = {
	row: TanstackRow<T>;
	interactionName?: CharlieTableProps<T>['interactionName'];
	analyticsContext?: CharlieTableProps<T>['analyticsContext'];
	labels?: CharlieTableProps<T>['labels'];
};

export const ExpandRowButton = <T extends object>({
	row,
	interactionName,
	analyticsContext,
	labels,
}: ExpandRowButtonProps<T>): React.JSX.Element => (
	<IconButton
		spacing="compact"
		testId="expand-row-button"
		appearance="subtle"
		interactionName={interactionName}
		analyticsContext={{
			componentName: 'charlieTableExpandRowButton',
			...analyticsContext,
		}}
		aria-expanded={row.getIsExpanded()}
		label={typeof labels?.expandRow === 'function' ? labels.expandRow(row) : labels?.expandRow}
		icon={(iconProps: { label: string }) => (
			<ExpandIcon isExpanded={row.getIsExpanded() ?? false} {...iconProps} />
		)}
		onClick={(e: React.MouseEvent) => {
			e.stopPropagation();
			row.toggleExpanded();
		}}
	/>
);
